export const viewers = {
  csv: () => import('./csv_viewer.vue?vue3'),
  download: () => import('./download_viewer.vue?vue3'),
  image: () => import('./image_viewer.vue'),
  video: () => import('./video_viewer.vue'),
  empty: () => import('./empty_viewer.vue'),
  text: () => import('../../../blob/components/source_viewer/source_viewer.vue?vue3'),
  pdf: () => import('./pdf_viewer.vue?vue3'),
  lfs: () => import('./lfs_viewer.vue?vue3'),
  audio: () => import('./audio_viewer.vue'),
  svg: () => import('./image_viewer.vue'),
  sketch: () => import('./sketch_viewer.vue?vue3'),
  notebook: () => import('./notebook_viewer.vue?vue3'),
  openapi: () => import('./openapi_viewer.vue'),
  geo_json: () => import('./geo_json/geo_json_viewer.vue?vue3'),
  too_large: () => import('./too_large_viewer.vue?vue3'),
};

export const loadViewer = (type, isUsingLfs, isTooLarge) => {
  let viewer = viewers[type];

  if (isTooLarge) {
    viewer = viewers.too_large;
  } else if (!viewer && isUsingLfs) {
    viewer = viewers.lfs;
  }

  return viewer;
};
